import { styled } from "@material-ui/core";

const CaiseSidebarSpace = styled('div')({
  width: '100%',
  flex: 1,
  flexBasis: '0%',
  flexGrow: 0.98,
  flexShrink: 1,
});

export default CaiseSidebarSpace
